<mat-dialog-actions class="justify-content-between p-b-0">
    <h4 class="f-s-16 f-w-600">
        {{ 'LABEL.PATIENT_PAYMENT' | translate}}:
        <span style="color: var(--mat-sys-primary);">{{patientName}}</span>
    </h4>
    <h5 class="f-s-14 f-w-700">
        {{ 'LABEL.BILL_NO' | translate}}:
        <span style="color: var(--mat-sys-primary);">{{billno}}</span>
    </h5>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-card class="no-shadow">
    <mat-card-content class="p-10">
        <!-- Table Section -->
        <div class="table-container table-wrapper">
            <div class="table-responsive">
                <ng-container *ngIf="dataSource.data.length>0">
                    <table mat-table [dataSource]="dataSource" class="w-100">
                        <ng-container matColumnDef="paymentDate">
                            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 " sticky>{{ 'ENTITY.PAYMENT' |
                                translate }} {{ 'LABEL.DATE' | translate }}</th>
                            <td mat-cell *matCellDef="let element; let i = index" class="p-x-16">
                                {{ element.paymentDate|date:'dd-MM-yyyy'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="amount">
                            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 " sticky>{{ 'LABEL.AMOUNT' |
                                translate }}</th>
                            <td mat-cell *matCellDef="let element; let i = index" class="p-x-16">
                                {{ element.amount| indianCurrency}}
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="align-items-center"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;let element"></tr>
                    </table>
                </ng-container>
            </div>

        </div>

    </mat-card-content>
</mat-card>